import React from "react";
import employees from "../../../../../utils/constants/employees";
import EmployeeColumn from "./EmployeeColumn";

const MAX_MOBILE_VISIBLE_EMPLOYEES = 16; // Must be divisible by COLUMN_LENGTH
const COLUMN_LENGTH = 4;
const VISIBLE_COLUMNS = 6;
const MOBILE_VISIBLE_COLUMNS = MAX_MOBILE_VISIBLE_EMPLOYEES / COLUMN_LENGTH;

let autoPlay;

function shuffle(array) {
    let currentIndex = array.length, temporaryValue, randomIndex;

    while (currentIndex !== 0) {

        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
    }

    return array;
}

function arrangeEmployees(employees, colSize) {
    return employees.reduce((result, employee, i) => {
        if (i % colSize) {
            result[result.length - 1].push(employee);
        } else {
            result.push([employee]);
        }
        return result;
    }, []).filter(col => col.length === colSize)
}

let EmployeeCarousel = React.createClass({
    getInitialState() {
        return {
            employeeList: [],
            shift: false,
            currentIndex: 0
        };
    },
    componentDidMount(){
        let length = employees.length;
        let max = length - length % 4;
        const stickies = shuffle(employees.filter(employee => employee.sticky)).slice(0, max);
        const normals = shuffle(employees.filter(employee => !employee.sticky)).slice(0, max - stickies.length);
        let result;

        if (stickies.length === max) {
            result = stickies;
        } else if (stickies.length >= MAX_MOBILE_VISIBLE_EMPLOYEES) {
            const mobileStickies = stickies.slice(0, MAX_MOBILE_VISIBLE_EMPLOYEES);
            const extraStickies = stickies.slice(MAX_MOBILE_VISIBLE_EMPLOYEES, stickies.length);

            result = mobileStickies.concat(shuffle(extraStickies.concat(normals)));
        } else {
            const mobileNormals = normals.slice(0, MAX_MOBILE_VISIBLE_EMPLOYEES - stickies.length);
            const extraNormals = normals.slice(MAX_MOBILE_VISIBLE_EMPLOYEES - stickies.length, normals.length);

            result = shuffle(stickies.concat(mobileNormals)).concat(extraNormals);
        }

        this.setState({
            employeeList: arrangeEmployees(result, COLUMN_LENGTH)
        });

        autoPlay = setInterval(() => {
            let newState = {
                shift: true
            };

            this.setState(newState);

            setTimeout(() => {
                this.setState({
                    shift: false,
                    currentIndex: (this.state.currentIndex + 1) % this.state.employeeList.length
                });
            }, 2000);

        }, 6000);
    },
    componentDidUnmount() {
        if (autoPlay) {
            clearInterval(autoPlay);
        }
    },
    render() {
        const { employeeList: columnList, currentIndex } = this.state;

        return (
            <section className="eo-employees grid-10 no-gutter">
                <div className="eo-employees-inner hide-s">
                    <ul className={["eo-people-grid grid-10", (this.state.shift ? "shift" : "")].join(" ")}>
                        {
                            columnList.filter((col, i) => i < VISIBLE_COLUMNS + 1).map((col, i) => {
                                return (
                                    <li className="employee-col" key={`col-${i}`}>
                                        <EmployeeColumn items={columnList[(currentIndex + i) % columnList.length]}/>
                                    </li>
                                );
                            })
                        }
                    </ul>
                </div>
                <div className="eo-employees-inner-s hide-m hide-l hide-xl">
                    <ul className="eo-people-grid-s grid-10">
                        {
                            columnList.filter((col, i) => i < MOBILE_VISIBLE_COLUMNS).map((col, i) => {
                                return (
                                    <li className="employee-col-s grid-5" key={`col-${i}`}>
                                        <EmployeeColumn items={columnList[i]}/>
                                    </li>
                                );
                            })
                        }
                    </ul>
                </div>
            </section>
        );
    }
});

export default EmployeeCarousel;



/** WEBPACK FOOTER **
 ** ./app/views/anonymous/views/our-story/components/EmployeeCarousel.js
 **/